import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const NewBoard = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 24 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        d="M15.5 3H10.5V14C10.5 14.5523 10.9477 15 11.5 15L14.5 15C15.0523 15 15.5 14.5523 15.5 14V3Z"
        fill="#2D425B"
        fillOpacity="0.05"
      />
      <path
        d="M22.5 3H16.5V16C16.5 16.5523 16.9477 17 17.5 17L21.5 17C22.0523 17 22.5 16.5523 22.5 16V3Z"
        fill="#2D425B"
        fillOpacity="0.05"
      />
      <path
        d="M8.5 3H2.5V21C2.5 21.5523 2.94771 22 3.5 22L7.5 22C8.05228 22 8.5 21.5523 8.5 21V3Z"
        fill="#2D425B"
        fillOpacity="0.05"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.58696 4H3.5L3.5 21H7.58696L7.58696 4ZM3.5 3C2.94772 3 2.5 3.44771 2.5 4V21C2.5 21.5523 2.94771 22 3.5 22H7.58696C8.13924 22 8.58696 21.5523 8.58696 21V4C8.58696 3.44772 8.13924 3 7.58696 3H3.5ZM14.5 4H10.5V14L14.5 14V4ZM10.5 3C9.94772 3 9.5 3.44772 9.5 4V14C9.5 14.5523 9.94772 15 10.5 15H14.5C15.0523 15 15.5 14.5523 15.5 14V4C15.5 3.44772 15.0523 3 14.5 3H10.5ZM17.413 4H21.5V17H17.413L17.413 4ZM16.413 4C16.413 3.44772 16.8608 3 17.413 3H21.5C22.0523 3 22.5 3.44772 22.5 4V17C22.5 17.5523 22.0523 18 21.5 18H17.413C16.8608 18 16.413 17.5523 16.413 17V4Z"
        fill={color}
      />
      <path
        d="M23 18C23 20.7614 20.7614 23 18 23C15.2386 23 13 20.7614 13 18C13 15.2386 15.2386 13 18 13C20.7614 13 23 15.2386 23 18Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5 15.4286C18.5 15.1524 18.2761 14.9286 18 14.9286C17.7238 14.9286 17.5 15.1524 17.5 15.4286V17.5H15.4999C15.2238 17.5 14.9999 17.7239 14.9999 18C14.9999 18.2761 15.2238 18.5 15.4999 18.5H17.5V20.5714C17.5 20.8476 17.7238 21.0714 18 21.0714C18.2761 21.0714 18.5 20.8476 18.5 20.5714V18.5H20.6428C20.9189 18.5 21.1428 18.2761 21.1428 18C21.1428 17.7239 20.9189 17.5 20.6428 17.5H18.5V15.4286Z"
        fill="white"
      />
    </svg>
  )
})

export default NewBoard
